import { quickactionsType } from '../../types';
import { getCommandQuery, type IGetQuery, type IResponse } from '../api-utils';
import * as utils from '../utils';

export const create_QuickActions = ({
	data,
	onFailure,
	onSuccess,
}: IResponse & {
	data: {
		name: string;
	};
}) =>
	utils.httpPostMethod({
		apiData: {
			url: '/api/v1/QuickActions',
			header: utils.header(),
			data,
		},
		actionType: quickactionsType.create_QuickActions,
		onSuccess,
		onFailure,
	});

export const get_QuickActions = ({ onFailure, onSuccess, query, paged }: IGetQuery) =>
	utils.httpGetMethod({
		apiData: {
			url: `/api/v1/QuickActions${getCommandQuery(paged, ...(query || []))}`,
			header: utils.header(),
		},
		actionType: quickactionsType.get_QuickActions,
		onSuccess,
		onFailure,
	});
